import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface LandCostProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const LandCost: React.FC<LandCostProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [landCost, set_landCost] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Land Cost']?.['Land Cost'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Land Cost': { ...b.values?.['Land Cost'], 'Land Cost': v } } })
    );
    const label = 'Land Cost (Must tie to purchase and sale contract)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(landCost)}
                />
            ) : (
                <MoneyBox
                    id={'landCost'}
                    allowNegative={false}
                    value={landCost}
                    onChange={(value) => set_landCost(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
